export const CORE_PACKAGES_NAME = "core-packages";

export enum CorePackagesComponent {
  PackagesSearch = "PackagesSearch",
  PackagePill = "PackagePill",
  PackageSelectRadioGroup = "PackageSelectRadioGroup",
  PackagePrice = "PackagePrice",
  PackageAvailabilitySearch = "PackageAvailabilitySearch",
  HomePagePackageSearch = "HomePagePackageSearch",

  //Page
  PackageSearchPage = "PackageSearchPage",
  PackagesHotelAvailability = "PackagesHotelAvailability",
  PackagesHotelShop = "PackagesHotelShop",
  PackageReviewPage = "PackageReviewPage",

  //Hotels
  PackagesHotelCardPrice = "PackagesHotelCardPrice",
  PackageHotelRoomCardRates = "PackageHotelRoomCardRates",

  //Flights
  PackageFlightFareGridItem = "PackageFlightFareGridItem",
  PackageFlightCardFareList = "PackageFlightCardFareList",
  PackageFlightDeparturePage = "PackageFlightDeparturePage",
}
